import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const state = {
  activityTopic: '',
  screenWidth: document.documentElement.clientWidth
}

const mutations = {
  setTopicStatus (state, val) {
    state.activityTopic = val
  }
}

export default new Vuex.Store({
  state,
  mutations
})
